import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetAttributionDashboardV1Query } from './get-attribution-dashboard-v1-request';
import type { IGetAttributionDashboardV1Response } from './get-attribution-dashboard-v1-response';
import { getAttributionDashboardV1ResponseSchema } from './get-attribution-dashboard-v1-response';

export async function getAttributionDashboardV1Api(
  query: IGetAttributionDashboardV1Query = {},
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetAttributionDashboardV1Response>> {
  const params = new URLSearchParams();
  if (query.period) {
    params.set('period', query.period);
  }
  const qs = params.toString();
  return getRequest<IGetAttributionDashboardV1Response>({
    path: `/sys/attribution/v1/dashboard${qs ? `?${qs}` : ''}`,
    schema: getAttributionDashboardV1ResponseSchema,
    options,
  });
}
